import script from "./DefModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DefModal.vue?vue&type=script&setup=true&lang=js"

import "./DefModal.vue?vue&type=style&index=0&id=51791f96&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51791f96"]])

export default __exports__